import { useEffect, useState } from "react";
import type { PaginationMeta } from "../components/ui/pagination.js";

/** Default rows per page for client-paged lists, matching the Expenses list. */
export const DEFAULT_PAGE_SIZE = 20;

/**
 * Client-side pages over a list that is already fully loaded, for the shared
 * `<Pagination>` footer. Resets to page 1 when the list changes shape (`resetKey`,
 * e.g. a new search or filter), and steps back if the current page empties.
 */
export function usePaged<T>(items: T[], resetKey: string, pageSize = DEFAULT_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  useEffect(() => setPage(1), [resetKey]);

  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const current = Math.min(page, totalPages);
  const meta: PaginationMeta = { total: items.length, page: current, limit: pageSize, totalPages };
  const offset = (current - 1) * pageSize;
  const pageItems = items.slice(offset, offset + pageSize);
  return { pageItems, meta, offset, setPage };
}
